import React, { useState, useEffect } from 'react';
import Cookies from "js-cookie";
import logo from "../src/images/logo.webp";
import Question from "../src/images/chatIcon.jpg";
import Facebook from "../src/images/fb.webp";
import Youtube from "../src/images/youtube.webp";
import Tiktok from "../src/images/tiktok.webp";
import Insta from "../src/images/insta.webp";
import Input from 'react-phone-number-input/input'
import 'react-phone-number-input/style.css';
import { Helmet } from 'react-helmet';
import moment from "moment";

const ThankYou = () => {
  const currentTime = moment().format('X');
  console.log("currentTime", currentTime);
  useEffect(() => {
    const refreshData = Cookies.get("refresh");
    if (refreshData > 11) {
      window.location.reload();
      Cookies.set("refresh", JSON.stringify(1));
    }
    else {
      Cookies.set("refresh", JSON.stringify(1));

    }
    // window.location.reload();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  useEffect(() => {
  }, []);
  const [key, setKey] = useState(0);
  const userDataString = Cookies.get("UserData");
  if (!userDataString) {
    window.location.replace('https://class.ourrealsuccess.com/');
  } else {
    var userData = JSON.parse(userDataString);
    console.log("userData", userData)
  }

  // console.log("userData", userData)
  const stringValue = userData.formattedDate.replace(/-/g, '');
  const starttimingclnder = moment(userData.startTime, 'h:mm A').format('HHmmss')
  const startTimeing = starttimingclnder.replace(/:|\s/g, '');
  const address = `${userData.hotel}, ${userData.street}, ${userData.city},${userData.state} ${userData.zipcode}`;
  const completeAddress = address.replace("&", "%26");
  const endTimeingclnder = moment(userData.endTime, 'h:mm A').format('HHmmss')
  const endTimeing = endTimeingclnder.replace(/:/g, "");
  // const endTimeCL = userData.endTime;
  console.log("endTimeing", endTimeing)
  console.log("endTimeingclnder", endTimeingclnder)

  const [formValues, setFormValues] = useState({
    guestFirstName: '',
    guestLastName: '',
    guestEmail: '',
    guestNumber: ''
  });
  const [errors, setErrors] = useState({ guestFirstName: '', guestLastName: '', guestEmail: '', guestNumber: '' });
  const [success, setSuccess] = useState(false)

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    let valid = true;
    const newErrors = { guestFirstName: '', guestLastName: '', guestEmail: '', guestNumber: '' };


    if (formValues.guestFirstName.trim() === '') {
      newErrors.guestFirstName = 'First Name is required';
      valid = false;
    }
    if (formValues.guestLastName.trim() === '') {
      newErrors.guestLastName = 'Last Name is required';
      valid = false;
    }
    if (!formValues.guestNumber || formValues.guestNumber.trim() === "") {
      newErrors.guestNumber = "Phone number is required";
      valid = false;
    } else if (formValues.guestNumber.length < 12) {
      newErrors.guestNumber = "Correct Phone number is required";
      valid = false;
    }
    else if (formValues.guestNumber.length > 12) {
      newErrors.guestNumber = "Correct Phone number is required";
      valid = false;
    }
    if (userData.email === formValues.guestEmail) {
      newErrors.guestEmail = 'This email is already being used, Please use guest email.';
      valid = false;
    }
    if (userData.number === formValues.guestNumber) {
      newErrors.guestNumber = 'This number is already being used, Please use guest number.';
      valid = false;
    }
    if (formValues.guestEmail.trim() === '') {
      newErrors.guestEmail = 'Guest Email is required';
      valid = false;
    }
    const updatedFormValues = {

      guestFirstName: formValues.guestFirstName,
      guestLastName: formValues.guestLastName,
      guestEmail: formValues.guestEmail,
      guestNumber: formValues.guestNumber,
      primaryContactFirstName: userData.fname,
      primaryContactLastName: userData.lname,
      dateName: userData.dateName,
      monthName: userData.monthName,
      dateStr: userData.dateStr,
      dayName: userData.dayName,
      selectedOption: userData.selectedOption,
      startTime: userData.startTime,
      endTime: userData.endTime,
      formattedDate: userData.formattedDate,
      hotel: userData.hotel,
      street: userData.street,
      lobyName: userData.lobyName,
      city: userData.city,
      zipcode: userData.zipcode,
      state: userData.state,
      hotelPhone: userData.hotelPhone,
      campaign: userData.campaign,
      utmSource: userData.utmSource,
      utmMedium: userData.utmMedium,
      utmCampaign: userData.utmCampaign,
      locationName: userData.locationName

    };


    if (valid) {
      const response = await fetch('https://services.leadconnectorhq.com/hooks/kJOiQyFsJQQj5rYEbrCO/webhook-trigger/345b2afa-3b9d-49d7-878d-b6fdd5318bf5', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedFormValues)
      });

      if (response.ok) {
        setSuccess(true);
        // Code to handle successful form submission goes here

        setIsLoading(false);

        window.location.replace('https://realsuccesseducation.com/2-hour-class-ty');

      } else {
        // Code to handle form submission error goes here

      }
    } else {
      setIsLoading(false);

      setErrors(newErrors);
    }
  }

  //   "20230315T1230PM"
  const formSrc = `https://www.google.com/calendar/render?action=TEMPLATE&text=2-Hour Real Estate Investment Class - RealSuccess&dates=${stringValue}T${startTimeing}/${stringValue}T${endTimeing}&details=📢 Congratulations on attending the 2-hour in-person real estate investment workshop!%0A %0A🚨 This is a SOLD OUT event, so congratulations on securing your ticket. We’re excited to have you join us!%0A%0AWe will show you our time-tested process to:%0A🔨 Rehab and flip houses%0A📜 Wholesale properties quickly%0A💰 Acquire cash-flow properties in the best turnkey rental markets%0A🏢 Invest in multifamily real estate%0A%0AGet ready to learn from experienced investors and take the next step toward financial freedom! 🚀&location=${completeAddress}`;

  // Installation script generated by Ad Analytics

  const AdScript = `
  (function(w, d) {
    var id = 'pdt-capture',
      n = 'cript';

    if (!d.getElementById(id)) {
      w.spdt = w.spdt || function() {
        (w.spdt.q = w.spdt.q || []).push(arguments);
      };

      var e = d.createElement(n);
      e.id = id;
      e.async = 1;
      e.src = 'https://pixel.byspotify.com/ping.min.js';

      var s = d.getElementsByTagName(n)[0];
      s.parentNode.insertBefore(e, s);
    }

    w.spdt('conf', { key: 'a9d12a39cf7e41c0b0273e19eef95df8' });
    w.spdt('purchase', {
      order_id: '${currentTime}', // Dynamically populate from session data
      discount_code: '', // Dynamically populate from session data
      is_new_customer: '', // Dynamically populate from session data
      value: '', // Dynamically populate from session data
      currency: '',
    });
  })(window, document);
`;
  console.log("AdScript", AdScript)

  return (
    <div className="thank-you-page">
      <Helmet key={key}>
        {/* <!-- Facebook Pixel Code --> */}

        <script>{`
         !function(f,b,e,v,n,t,s)
         {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
         n.callMethod.apply(n,arguments):n.queue.push(arguments)};
         if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
         n.queue=[];t=b.createElement(e);t.async=!0;
         t.src=v;s=b.getElementsByTagName(e)[0];
         s.parentNode.insertBefore(t,s)}(window, document,'script',
         'https://connect.facebook.net/en_US/fbevents.js');
         fbq('init', '319878429693238');
         fbq('track', 'Lead');
        `}</script>

        {/* <!-- TIKTOK Pixel Code --> */}
        <script>{`
         !function (w, d, t) {
          w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
        
          ttq.load('CFUH7KBC77U840VNCFO0');
          ttq.track('CompleteRegistration')
          ttq.page();
        }(window, document, 'ttq');
        `}</script>
        {/* <!-- Google tag (gtag.js) --> */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-630361343"></script>
        <script>
          {` window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'AW-630361343');`}
        </script>
        <script>
          {`   gtag('event', 'conversion', {
      'send_to': 'AW-630361343/UBxVCKGI19IBEP-ZyqwC',
      'value': 1.0,
      'currency': 'USD'
  });
`}
        </script>

        {/* <!-- Event snippet for Submit lead form conversion page --> */}
        <script>
          {` gtag('event', 'conversion', {'send_to': 'AW-48S6E6PYMQ/UBxVCKGI19IBEP-ZyqwC'});`}
        </script>
        {/* <!-- Event snippet for Submit lead form conversion page --> */}
        {/* // Installation script generated by Ad Analytics */}
        <script>{AdScript}</script>

        {/* <!-- Podscribe pixel --> */}
        <script>{`
      (function (w, d) {
        var id = 'podscribe-capture',
        n = 'script';
        var e = d.createElement(n);
        e.id = id;
        e.async = true;
        e.src = 'https://d34r8q7sht0t9k.cloudfront.net/tag.js';
        var s = d.getElementsByTagName(n)[0];
        s.parentNode.insertBefore(e, s);
        e.addEventListener('load', function() {
          w.podscribe('init', { user_id: '8ce08595-0524-45c9-b1a0-62916831de14', advertiser: 'realsuccess' });
          w.podscribe('lead', {
            //Replace the placeholder strings below with your macros!
            product: '${userData.email}',
          });
        })
      })(window, document);
    
        `}</script>
        {/* <!-- /Podscribe pixel --> */}


      </Helmet>

      <div className="confirm-btn-clss">

        <img src="https://strategicmedia-23-adswizz.attribution.adswizz.com/fire?pixelId=38d69dd6-665f-4033-9b75-5c0f03d44b1b&type=sitevisit&subtype=Purchase1&aw_0_req.gdpr=true&redirectURL=aHR0cHM6Ly9waXhlbC50YXBhZC5jb20vaWRzeW5jL2V4L3JlY2VpdmU_cGFydG5lcl9pZD0yOTk0JjwjaWYgcmVxdWVzdC5saXN0ZW5lcklkP21hdGNoZXMoJ1swLTlhLWZdezh9LVswLTlhLWZdezR9LVswLTlhLWZdezR9LVswLTlhLWZdezR9LVswLTlhLWZdezEyfScpPnBhcnRuZXJfdHlwZWRfZGlkPSU3QiUyMkhBUkRXQVJFX0FORFJPSURfQURfSUQlMjIlM0ElMjIke3JlcXVlc3QubGlzdGVuZXJJZH0lMjIlN0Q8I2Vsc2VpZiByZXF1ZXN0Lmxpc3RlbmVySWQ_bWF0Y2hlcygnWzAtOUEtRl17OH0tWzAtOUEtRl17NH0tWzAtOUEtRl17NH0tWzAtOUEtRl17NH0tWzAtOUEtRl17MTJ9Jyk-cGFydG5lcl90eXBlZF9kaWQ9JTdCJTIySEFSRFdBUkVfSURGQSUyMiUzQSUyMiR7cmVxdWVzdC5saXN0ZW5lcklkfSUyMiU3RDwjZWxzZT5wYXJ0bmVyX2RldmljZV9pZD0ke3JlcXVlc3QubGlzdGVuZXJJZCF9PC8jaWY-" />

      </div>

      <div className="thank-header page-cointaner">
        <h1><i>JOE'S</i>  REAL ESTATE CLASS</h1>

        {/* <div className="header-inner">
           <img src={Question} alt="Question" />
            <p>
              Question? <br />
              Call 1-800-304-1799
            </p>
           </div> */}

      </div>
      <div className="congraultion">
        <div className="page-cointaner">
          <h2>Congratulations, {userData.fname} !</h2>
          <p>You are now registered!</p>
          <h6 className='color-white'>Your event confirmation & Funding Deals Guide will be sent to you <em>{userData.email}</em> shortly.</h6>

        </div>
      </div>
      <div className='socail-links'>
        <h2>Follow Joe Arias</h2>
        <div className='socail-links-inner'>
          <div>

            <a href="https://www.instagram.com/joeariasinvestor/" target="_blank"> <img src={Insta} alt="Insta" /></a>
          </div>
          <div>
            <a href="https://www.facebook.com/joeariasbuilder" target="_blank"> <img src={Facebook} alt="Facebook" /></a>

          </div>
          <div>
            <a href="https://www.tiktok.com/@joearias_investor?is_from_webapp=1&sender_device=pc" target="_blank"><img src={Tiktok} alt="Tiktok" /></a>

          </div>
          <div>
            <a href="https://www.youtube.com/channel/UCif98Y0uvl2_5Xh1ZhjLe5g" target="_blank"> <img src={Youtube} alt="Youtube" /></a>

          </div>

        </div>
      </div>

      <div>
        <div className="page-cointaner next-step">
          <div className="nextstep ">
            <h2>You Next Step: Register Your Guest</h2>
            <iframe src="https://player.vimeo.com/video/625026316?h=512ad66c19&title=0&byline=0&portrait=0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={{ width: '100%', height: '100%' }}></iframe>

            <div>
              <p>
                As part of your class registration, you have received <strong>one (1) Free
                  Guest Ticket.</strong> Take Advantage of it &amp; bring a spouse, friend
                or business partner with you!
              </p>
            </div>

            <form className="modal-form thank-you-form" data-ghl-ignore="true">
              <label>
                Guest First Name
                <input type="text" name="guestFirstName" value={formValues.guestFirstName} onChange={(event) => setFormValues({ ...formValues, guestFirstName: event.target.value })} />
                {errors.guestFirstName && <div className="error">{errors.guestFirstName}</div>}
              </label>
              {/* <br /> */}
              <label>
                Guest Last Name
                <input type="text" name="guestLastName" value={formValues.guestLastName} onChange={(event) => setFormValues({ ...formValues, guestLastName: event.target.value })} />
                {errors.guestLastName && <div className="error">{errors.guestLastName}</div>}
              </label>
              {/* <br /> */}
              <label>
                Guest Email
                <input type="email" name="guestEmail" value={formValues.guestEmail} onChange={(event) => setFormValues({ ...formValues, guestEmail: event.target.value })} />
                {errors.guestEmail && <div className="error">{errors.guestEmail}</div>}
              </label>
              {/* <br /> */}
              <label>
                Guest Number
                <Input
                  country="US"
                  international
                  withCountryCallingCode
                  name="guestNumber"
                  placeholder='Number'
                  onChange={(value) => setFormValues({ ...formValues, guestNumber: value })} />
                {errors.guestNumber && <div className="error">{errors.guestNumber}</div>}
              </label>
              <div className='submit-form'>
                <button type="button" className="submit_btn_form" onClick={handleSubmit} disabled={isLoading}>
                  {isLoading ? 'Loading...' : 'Reserve Your Seat'}
                </button>
                {/* <input type="submit" value="Reserve Your Seat" /> */}
              </div>
            </form>



            {/* <h6>Your event confirmation & Money Resource Guide will be delivered to <em>{userData.email}</em> shortly.</h6> */}
            {success && <h5 className='mt-2 congration_guest'>Congratulations, your guest seat is confirmed. <br /><span>Your guest will receive  their event confirmation shortly.</span></h5>}
          </div>


          <div className="addtocalender page-cointaner next-step">
            <h2>Step 2: Add to Calendar</h2>
            {/* <p>Class starts at <strong>{userData.startTime} </strong>at the <strong>{userData.hotel}</strong> on <strong>{userData.dayName}, {userData.dateStr}</strong>.</p> */}
            <p> <strong>Date: </strong>{userData.dateStr} <br /><strong>Time: </strong>{userData.startTime} <br /><strong>Location: </strong>{userData.hotel}, {userData.street}, {userData.city}, {userData.state} {userData.zipcode}</p>
            <p>This is an event you won't want to miss, please take a moment to add it to your calendar.</p>
            {/* <h2>Add Event To Your Calendar</h2> */}

            <div className='add-to-calender'>
              <a
                target="_blank"
                rel="noopener noreferrer nofollow"
                href={formSrc}
              >
                Add To Your Calendar
              </a>
            </div>
          </div>

          <div className="addtocalender page-cointaner next-step">
            <h2>Step 3: Arrive Ready To Learn</h2>
            <p>This class will cover the same systems and techniques JOE and his  team have used to buy & sell hundreds of properties over the past 10+ years.</p>

            <p>Bring your favorite note taking device because you will want to write down your favorite strategies and techniques during the class. We will have a Q&A at the end of class to make sure all your questions are answered!</p>
            <p>Other than a little enthusiasm and an open mind as to what's possible for you & your family through real estate!</p>
          </div>



          <div className="addtocalender page-cointaner next-step">
            <div className="thank-header page-cointaner">
              <div className="header-inner">
                <img src={Question} alt="Question" />
                <p>
                  Question? <br />
                  Call 1-800-304-1799
                </p>
              </div>

            </div>
          </div>

        </div>
      </div>
      <div className="thank-footer">
        <div className="page-cointaner">
          <img src={logo} alt="logo" />
          <p></p>
          <p>Copyright @ 2026. RealSuccess Investments.</p>
          <p>
            We offer free workshops and advanced education. We do not partner up
            with investors or sell a franchise or a done-for-you business.
            Learning real estate takes time and energy, we do not believe people
            can become wealthy in just a few months of investing in real estate.
            It takes effort, commitment, timing on the market, knowledge,
            systems and many other factors. We are not financial consultants and
            do not guarantee earnings or returns on investment. We hace no
            license to offer financial, tax, or legal advice. Investing can be
            riskly and my result in partial or total loss. This site is not
            endorsed by Facebook, Instagram, Google in any way, shape or form.
            RealSuccess Investments is a real estate investment company
            committed to create active and passive income for our investors and
            people we do business with.{" "}
          </p>
          <p></p>
        </div>
      </div>

    </div>
  );
};

export default ThankYou;
